import Vue from "vue";
import VueI18n from "vue-i18n";

import {
	getLanguage
} from "@/utils/lang";

import enLocale from "./en_us.js";
import zhLocale from "./zh_cn.js";

import {
	Locale
} from "vant";

import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";

Vue.use(VueI18n);

const messages = {
	en: {
		...enUS,
		...enLocale
	},
	zh_CN: {
		...zhCN,
		...zhLocale
	}
};

export const getLocale = () => {
	const cookieLanguage = getLanguage();
	if (cookieLanguage) {
		document.documentElement.lang = cookieLanguage;
		return cookieLanguage;
	}

	const language = (
		navigator.language || navigator.browserLanguage
	).toLowerCase();
	const locales = Object.keys(messages);
	for (const locale of locales) {
		if (language.indexOf(locale) > -1) {
			document.documentElement.lang = locale;
			return locale;
		}
	}
	return "zh_CN";
};

const CURRENT_LANG = getLocale();

Locale.use(CURRENT_LANG, messages[CURRENT_LANG]);

const i18n = new VueI18n({
	locale: CURRENT_LANG,
	messages
});

export default i18n;
